import React from 'react';
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg';
import { Tooltip } from 'components';
import PropTypes from 'prop-types';

const InfoMessage = ({ infoMessage, overlayClassName, iconClassName, placement = 'topRight' }) => {
  return (
    <>
      {infoMessage && (
        <div className="pl-1 d-flex">
          <Tooltip
            key={infoMessage}
            overlayClassName={overlayClassName}
            title={infoMessage}
            placement={placement}
          >
            <InfoIcon
              className={`info-icon ${iconClassName ? iconClassName : ''}`}
            />
          </Tooltip>
        </div>
      )}
    </>
  );
};

InfoMessage.propTypes = {
  overlayClassName: PropTypes.string,
  infoMessage: PropTypes.string,
};

export default InfoMessage;
